module.exports = __webpack_public_path__ + "img/collect-blank-images@2x.7328beae.png";